module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Cms', {
    attrs: {
      "pageTitle": 'Conteúdo da Página de Parques',
      "pageName": 'parks'
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af241b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cms/ParksCms.vue
// module id = 687
// module chunks = 1